import dayjs from 'dayjs';
import 'dayjs/locale/nl';

dayjs.locale('nl');

// eslint-disable-next-line no-extend-native
Date.prototype.toJSON = function toJSON() {
    return dayjs(this).format('YYYY-MM-DDTHH:mm:ssZ');
};

const getDateObject = (date: string | Date) => {
    return dayjs(date);
};

const formatDate = (date: string | Date) => dayjs(date).format('DD-MM-YYYY');

const formatTime = (date: string | Date) => dayjs(date).format('HH:mm');

const formatDateTime = (date: string | Date) => dayjs(date).format('DD-MM-YYYY HH:mm');

const formatDayMonth = (date: string | Date) => dayjs(date).format('DD MMMM');

const formatDayTime = (date: string | Date): string => {
    const now = dayjs();
    const targetDate = dayjs(date);

    if (targetDate.isSame(now, 'day')) {
        return `Vandaag, ${targetDate.format('HH:mm')}`;
    }

    if (targetDate.isSame(now.subtract(1, 'day'), 'day')) {
        return `Gisteren, ${targetDate.format('HH:mm')}`;
    }

    // if this week
    if (targetDate.isBefore(now.subtract(1, 'day'), 'day') && targetDate.isAfter(now.subtract(5, 'days'), 'day')) {
        const dateString = targetDate.format('dddd, HH:mm');
        return dateString.charAt(0).toUpperCase() + dateString.slice(1);
    }

    return targetDate.format('D MMMM, HH:mm');
};

export {
    getDateObject,
    formatDate,
    formatTime,
    formatDateTime,
    formatDayMonth,
    formatDayTime,
};
